export interface IThemeCheckIn {
  themeTemplate: string;
  stationNumber: number;
}

export enum ThemeHomeCheckIn {
  CHECK_IN = 'CHECK_IN',
  GOOGLE_NOT_SHOW_REVIEW = 'GOOGLE_NOT_SHOW_REVIEW',
  GOOGLE_SHOW_REVIEW = 'GOOGLE_SHOW_REVIEW',
  MARKETING = 'MARKETING',
  MARKETING_NO_CHECKIN = 'MARKETING_NO_CHECKIN',
  CHECKIN_SHOP_LOGO_THEME = 'CHECKIN_SHOP_LOGO_THEME',
}

export interface IUpdateThemeCheckInBody {
  themeTemplate: string;
  stationNumber: number;
}

export enum MediaKindType {
    VIDEO = 'VIDEO',
    IMAGE = 'IMAGE',
}

export interface IUpdateSreenWaitingBody {
  id?: string;
  kindType: MediaKindType;
  url: string;
  orderNumber: number;
}

export interface IScreenWaiting {
  id: string;
  kindType: MediaKindType;
  url: string;
  orderNumber: number;
}